import { componentWithFG } from '@atlaskit/platform-feature-flags-react';

import { ImageFromUrlMemoed, ImageFromUrlRaw } from './raw';

export const ImageFromUrl = componentWithFG(
	'navx-3138-gas-menu-rendering-perf-fix',
	ImageFromUrlMemoed,
	ImageFromUrlRaw,
);
